// extracted by mini-css-extract-plugin
export default {"table":"styles_table__yd-cE","docName":"styles_docName__fQues"};